module.exports = __webpack_public_path__ + "static/media/D558GriffinStNW_2018-06-05_24.01231f26.jpg";